<template>
  <div>
    <el-collapse v-model="collapseActiveName" v-for="(item, index) in list" :key="index">
      <el-collapse-item title="危险源辨识" :name="'identify' + index">
        <EquipIdentify
          :disabled="true"
          v-if="isEquip"
          :taskId="item.equipmentFacilitySourcesDangerIdentifyId || item.jobSourcesDangerIdentifyId"
        />
        <JobIdentify
          :disabled="true"
          v-else
          :taskId="item.equipmentFacilitySourcesDangerIdentifyId || item.jobSourcesDangerIdentifyId"
        />
        <!-- ref="equipIdentify" -->
      </el-collapse-item>
      <el-collapse-item title="管控措施" :name="'control' + index">
        <ControlMeasure
          :identifyId="
            item.equipmentFacilitySourcesDangerIdentifyId || item.jobSourcesDangerIdentifyId
          "
          :disabled="true"
        />
        <!-- ref="controlMeasure" -->
      </el-collapse-item>
      <el-collapse-item title="风险评级" :name="'risk' + index">
        <RiskEvaluate
          :projectId="item.sourcesDangerRecognitionRiskRatingId"
          :taskId="item.sourcesDangerRecognitionPlanTaskId"
          :identifyId="
            item.equipmentFacilitySourcesDangerIdentifyId || item.jobSourcesDangerIdentifyId
          "
          :evaluateMethod="evaluateMethod"
          :isDisabled="true"
        />
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import ControlMeasure from './ControlMeasure'
import EquipIdentify from './EquipIdentify'
import JobIdentify from './JobIdentify'
import RiskEvaluate from './RiskEvaluate'

export default {
  name: 'collapse-list',
  components: {
    // SelectCheckItems,
    EquipIdentify,
    ControlMeasure,
    JobIdentify,
    RiskEvaluate,
  },
  props: {
    list: {
      default: () => {
        return []
      },
    },
    evaluateMethod: {
      default: 0,
      type: Number,
    },
    isEquip: {
      default: true,
    },
  },
  data() {
    return {
      collapseActiveName: [],
      taskList: [1, 2],
    }
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-collapse {
  border-top: 0px;
}
</style>
